import { dataLayerGtmSelectIem } from '../Services/Gtm.service.js';

(() => {
  document.addEventListener('click', (e) => {
    try {
      const ancestor = e.target.closest('[data-gtm-select-item]');

      if (ancestor) {
        const scriptTag = ancestor.querySelector('script[data-gtm-select-item-event]');

        if (scriptTag) {
          const item = JSON.parse(scriptTag.textContent);
          const listId = scriptTag.getAttribute('data-gtm-list-id');
          const listName = scriptTag.getAttribute('data-gtm-list-name');
          dataLayerGtmSelectIem(item, listId, listName);
        }
      }
    } catch (e) {
      console.warn(e);
    }
  });
})();